import React, { FunctionComponent } from 'react';
import { useQuery } from '@apollo/client';
import { resizeImageUrl } from '../../../shared/CdnImages';
import NoCoverImage from '../../../assets/no-cover-vertical.svg';
import GamePlayHistoryDetailsPopover from './GamePlayHistoryDetailsPopover';
import { NCOM_PRODUCT_BY_ID, Product } from './useGamePlay';
import { GamePlayDataModel } from './GamePlayDataModel';

export const GamePlayHistoryList: FunctionComponent<GamePlayDataModel> = ({
    applicationId,
    consumerId,
    playTime,
}) => {
    const { data: gameDetails, loading } = useQuery<
        { products: Product[] },
        { input: { applicationIds: string[] } }
    >(NCOM_PRODUCT_BY_ID, {
        variables: {
            input: {
                applicationIds: [applicationId],
            },
        },
    });

    const storeProduct =
        gameDetails?.products?.find((product: Product) =>
            product?.productImage?.publicId?.includes('store/'),
        ) || gameDetails?.products[0];

    const title = storeProduct?.name || (loading ? '' : 'Unavailable');
    const titleClassname = !loading && !storeProduct?.name ? ' font-italic' : '';
    const imageUrl = storeProduct?.productImage?.url || '';

    return (
        <li className="game-play-history-list__item py-3 d-flex align-items-center">
            <img
                src={imageUrl ? resizeImageUrl(imageUrl, 140) : NoCoverImage}
                alt=""
                width="140"
                height="80"
            />
            <div className={titleClassname}>{title}</div>
            <div className="ml-auto">
                <p className="m-0">
                    <strong>Play Time</strong>
                </p>
                <p className="mb-3">{playTime}</p>
                <p className="m-0">
                    <GamePlayHistoryDetailsPopover
                        applicationId={applicationId}
                        consumerId={consumerId}
                        buttonLabel="View Last 30 Days"
                        daysAgo={30}
                    />
                </p>
            </div>
        </li>
    );
};

export default GamePlayHistoryList;
